<template>
  <el-form
    :model="user"
    ref="userForm"
    class="userForm"
    label-position="top"
  >
    <el-form-item
      class="el-webcam"
    >
      <web-cam
        ref="webcam"
        drag
        :device-id="deviceId"
        width="100%"
        height="auto"
        @cameras="onCamera"
        v-show="!isPhotoTaken"
      />
      <el-form-item
        class="userPhoto"
        v-show="isPhotoTaken"
        prop="patientPhoto"
      >
        <Uploader
          :base64.sync="patientPhoto"
          @showLoader="showLoader"
          @imageUploaded="uploadedImg"
        />
      </el-form-item>

      <el-row class="btn-wrapper">
        <el-button
          type="button"
          class="btn btn-primary"
          @click="onCapture"
          v-show="!isPhotoTaken"
        >
          Take a photo
        </el-button>
        <el-button
          type="button"
          class="btn btn-primary"
          @click="onCapture"
          v-show="isPhotoTaken"
        >
          Take another photo
        </el-button>
        <el-upload
          accept=".jpeg,.jpg,.png"
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="onUploadImage"
          v-show="!isPhotoTaken"
        >
          <el-button
            type="button"
            class="btn btn-primary"
          >
            Select existing photo
          </el-button>
        </el-upload>
      </el-row>
    </el-form-item>
    <el-form-item
      label="First Name"
      prop="firstName"
    >
      <el-input
        type="text"
        :value="user.firstName"
        disabled
      />
    </el-form-item>
    <el-form-item
      label="Last Name"
      prop="lastName"
    >
      <el-input
        type="text"
        :value="user.lastName"
        disabled
      />
    </el-form-item>
    <el-form-item
      label="Date of Birth"
      prop="dateOfBirth"
    >
      <el-date-picker
        type="date"
        placeholder="Pick a date"
        :value="user.dateOfBirth"
        style="width: 100%;"
        format="MM/dd/yyyy"
        disabled
      />
    </el-form-item>
    <el-form-item
      label="Cell Phone"
      prop="cellPhone"
    >
      <the-mask
        mask="+1 (###) ###-####"
        v-model="user.cellPhone"
      />
    </el-form-item>
    <el-form-item
      label="Home Phone"
      prop="homePhone"
    >
      <the-mask
        mask="+1 (###) ###-####"
        v-model="user.homePhone"
      />
    </el-form-item>
    <el-form-item class="submit-btn">
      <el-button
        type="primary"
        @click="submitForm('userForm')"
      >
        Save
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { WebCam } from "vue-web-cam";
import Uploader from '../form/Uploader';

export default {
  name: 'Profile',
  components: {
    WebCam,
    Uploader
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      deviceId: null,
      devices: [],
      isPhotoTaken: false,
      file: null,
      patientPhoto: ''
    };
  },
  created () {
    this.setProfileImage().then((response) => {
      if (response) {
        this.isPhotoTaken = !this.isPhotoTaken;
      } else {
        this.isPhotoTaken = false;
      }
    });
  },
  watch: {
    devices: function() {
      this.deviceId = this.devices[0].deviceId;
    }
  },
  methods: {
    showLoader() {
      this.$emit('screenLoading', true);
    },
    uploadedImg() {
      this.file = this.patientPhoto;
      this.$emit('screenLoading', false);
    },
    onCapture () {
      this.patientPhoto = this.$refs.webcam.capture();
      this.file = this.convertToBlobData(this.patientPhoto);
      this.isPhotoTaken = !this.isPhotoTaken;
    },
    onCamera (camera) {
      this.devices = camera;
    },
    onUploadImage (file) {
      this.file = file.raw;
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = function () {
          resolve(reader.result);
        };
      }).then((data) => {
        this.isPhotoTaken = !this.isPhotoTaken;
        this.patientPhoto = data;
      });
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveProfile();
        } else {
          return false;
        }
      });
    },
    convertToBlobData (data) {
      const bytes = [],
            binary = atob(data.split(',')[1]),
            dataType = data.split(',')[0].split(':')[1].split(';')[0];

      for (let i = 0; i < binary.length; i++) {
        bytes.push(binary.charCodeAt(i));
      }

      return new Blob([ new Uint8Array(bytes) ],{ type: dataType });
    },
    saveProfileImage () {
      this.$emit('screenLoading', true);
      const data = new FormData();

      data.append('blobData', this.file);
      data.append('patientNumber', this.user.patientNumber);

      return this.$axios('/Patient/SavePatientProfileImage', {
        method: 'POST',
        headers: { 'content-type': 'multipart/form-data' },
        data: data
      }).then((response) => {
        if (response.data) {
          if (!response.data.length) {
            if (!response.data.isSuccess) {
              this.$emit('screenLoading', false);
              this.$message.warning(response.data.errorMessage);
              return false;
            }
          } else {
            this.setProfileImage();
            return true;
          }
        }
      }).catch(() => {
        this.$emit('screenloading', false);
        this.$message.warning('Oops, something went wrong!');
      });
    },
    updatedImage() {
      return this.file;
    },
    setProfileImage () {
      return this.$axios('/Patient/GetPatientProfileImage', {
        method: 'GET',
        params: {
          patientNumber: this.user.patientNumber
        },
        responseType: 'arraybuffer'
      }).then((response) => {
        if (response.data) {
          const imgStr = new Buffer.from(response.data, 'binary').toString('base64'),
                prefix = "data:" + response.headers["content-type"] + ";base64,";

          this.$set(this, 'patientPhoto', prefix + imgStr);
          return true;
        } else {
          this.$set(this, 'patientPhoto', '');
          return false;
        }
      });
    },
    saveProfile () {
      this.$emit('screenLoading', true);
      this.$axios('/Patient/UpdatePatientInfo', {
        method: 'PUT',
        data: {
          patientNumber: this.user.patientNumber,
          homePhone: this.user.homePhone,
          cellPhone: this.user.cellPhone
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.saveStatisticData(this.getSessionId(), {profile_save: 'true'});
          if (this.updatedImage()){
            this.saveProfileImage().then((response) => {
              if (response) {
                this.$emit('screenLoading', false);
                this.$message({
                  showClose: true,
                  message: 'User data is saved!',
                  type: 'success'
                });
              }
            }).catch(() => {
              this.$emit('screenLoading', false);
              this.$message({
                showClose: true,
                message: 'Profile image wasn\'t saved!',
                type: 'error'
              });
            });
          }
          else {
            this.$emit('screenLoading', false);
            this.$message({
              showClose: true,
              message: 'User data is saved!',
              type: 'success'
            });
          }
        } else {
          this.$emit('screenLoading', false);
          this.$message({
            showClose: true,
            message: 'Oops, something went wrong!',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.userForm::v-deep {

  label {
    padding: 0 !important;
  }

  .image-uploader {
    .image {
      max-height: 250px;
      object-fit: contain;
      width: auto;
      max-width: 350px;
    }
  }

  .el-webcam {
    max-width: 480px;
    margin: 0 auto;
    .el-form-item__content{
      text-align: center;
      line-height: 0;
    }
    .userPhoto{
      text-align: center;
    }
    video {
      max-width: 300px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    }
  }

  .btn-wrapper{
    display: flex;
    justify-content: space-evenly;
    padding: 10px 0;
    button {
      margin: 0;
    }
  }
}
</style>
